import { POLine } from './po-line.model';

export class PO_HEADER{
     PH_SEQ :any;
     PH_PURCHASE_INVOICE_NO :any;
     PH_DEPARTMENT :any='';
     PH_STRUCTURE :any='';
     PH_SUBMISSION_DATE :any='';
     PH_VENDOR_INVOICE_NO :any='';
     PH_LOCATION_CODE :any='';  
     PH_REMARKS :any='';
     PH_STATUS :any;
     PH_POSTED_INVOICE_NO:any='';
     PH_VENDOR_INVOICE_AMT :any;
     TotalPostedInvoiceAmount:number;
     RemainingAmount:number;
     PH_DOCUMENT_DATE:any='';
     PH_REASON_FOR_REJECTION:string='';
     PH_CONTACT_PERSON:string='';
     PH_PO_No:string='';    
     PH_CREATED_BY :any;
     PH_CREATED_ON :any;
     PH_MODIFIED_BY :any;
     PH_MODIFIED_ON :any;
     PH_ACTIVE :any;
     purchase_LineModels:POLine[];
     Files:any;
     VendorName:string='';
     PH_VENDOR_EMAIL:String='';
     PH_ORDER_ADDRESS_CODE:string='';
}